import { CurrencyPipe } from "@angular/common";
import { NgModule } from "@angular/core";
import { CustomPipe } from "./custom.pipe";
import { FormatDatePipe } from "./format-date.pipe";
import { LowerCaseFirstLetterPipe } from "./lower-case-first-letter.pipe";
import { MagicalPipe } from "./magical.pipe";
import { ReturnHtmlPipe } from "./return-html";
import { SanitizeHtmlPipe } from "./sanitizer-html.pipe";
import { UnitFormatPipe } from "./unit-format.pipe";

@NgModule({
    declarations: [
        ReturnHtmlPipe,
        FormatDatePipe,
        CustomPipe,
        MagicalPipe,
        SanitizeHtmlPipe,
        UnitFormatPipe,
        LowerCaseFirstLetterPipe,
    ],
    exports: [
        ReturnHtmlPipe,
        FormatDatePipe,
        CustomPipe,
        MagicalPipe,
        SanitizeHtmlPipe,
        UnitFormatPipe,
        LowerCaseFirstLetterPipe,
    ]
})
export class PipesModule { }
